var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4332 1.0987C17.7797 1.26522 18 1.6156 18 2V6C20.3482 6 22 8.1649 22 10.5C22 12.8351 20.3482 15 18 15V19C18 19.3844 17.7797 19.7348 17.4332 19.9013C17.0867 20.0678 16.6755 20.021 16.3753 19.7809L11.6492 16H11V22C11 22.5523 10.5523 23 10 23H5C4.44772 23 4 22.5523 4 22V16H3C2.44772 16 2 15.5523 2 15V6C2 5.44772 2.44772 5 3 5H11.6492L16.3753 1.21913C16.6755 0.978997 17.0867 0.932179 17.4332 1.0987ZM18 13C18.9655 13 20 12.0309 20 10.5C20 8.96912 18.9655 8 18 8V13ZM6 16H9V21H6V16ZM16 4.08063L12.6247 6.78087C12.4474 6.92272 12.2271 7 12 7H4V14H12C12.2271 14 12.4474 14.0773 12.6247 14.2191L16 16.9194V4.08063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaing);
export default __webpack_public_path__ + "static/media/campaing.f13dc56a.svg";
export { ForwardRef as ReactComponent };